package top.wcpe.allincore.ui.runtime.render.layer

/** 单帧实际回放阶段，顺序与 [LayerBufferingBridge] 的唯一回放出口一致。 */
enum class DrawTracePhase {
    BACKGROUND,
    CONTENT,
    ITEM,
    ENTITY,
    OVERLAY,
    FLOATING,
    SCREEN_MODAL,
    SCREEN_TOOLTIP,
}

/**
 * 实际回放顺序的只读投影。
 *
 * [record] 保留原始 [DrawRecord] 只读引用，不进入 IR、渲染命令或序列化协议。
 */
data class DrawTraceEntry(
    val phase: DrawTracePhase,
    val layerId: Int?,
    val sequence: Int,
    val record: DrawRecord,
) {
    /** 返回真实录制时绑定的运行时节点路径。 */
    fun nodePath(): String? = record.nodePath()
}

/** 运行时在真实能力决策点识别出的降级能力。 */
enum class UnsupportedRenderCapability {
    COLOR_MATRIX,
    FULL_TRANSFORM_3X3,
    FULL_TRANSFORM_4X4,
    FILTER_GROUP,
    BACKDROP_FILTER,
    BLEND_MODE,
    HISTORY_CAPTURE,
}

/**
 * 平台桥可选实现的只读观测接缝。
 *
 * 运行时只负责提供真实回放位置与降级类别，不依赖任何平台诊断编码。
 */
data class UnsupportedRenderContext(
    val phase: DrawTracePhase,
    val layerId: Int?,
    val sequence: Int,
)

interface DrawTraceObserver {
    fun onDrawTrace(entry: DrawTraceEntry)

    fun onUnsupportedCapability(capability: UnsupportedRenderCapability, entry: DrawTraceEntry)

    fun onUnsupportedCapability(capability: UnsupportedRenderCapability, context: UnsupportedRenderContext) = Unit
}

/** 仅供运行时内部把能力决策绑定到当前元素渲染作用域。 */
internal interface UnsupportedCapabilityCapture {
    fun beginUnsupportedContext()
    fun captureUnsupportedCapability(capability: UnsupportedRenderCapability)
    fun endUnsupportedContext()
}
